import { TableCell } from 'Components/Table/Table/Table';
import { Text } from 'Components/Text/Text';

import sharedStyles from '../../ThirdPartiesAndServicesListingSharedStyles.module.css';

export const TextCell = ({ children }: { children: string | undefined }) => {
    return <TableCell className={sharedStyles.parentCell}>{children !== undefined ? <Text noStyles>{children}</Text> : <></>}</TableCell>;
};
